/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.transportation.bus-stops'},
});

const BusStopsItem = () => (
  <RouteLinkItem
    route="midas/settings/transportation/bus-stops"
    title={messages.title}
  />
);

export default BusStopsItem;
